import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtomumbaicab() {



    const cardData = {


keyword: "Belgaum to Mumbai Cab",

headingDescription: "Belgaum Taxi Service provides safe, comfortable, and affordable Belgaum to Mumbai cab services for business travel, corporate meetings, airport transfers, family vacations, medical visits, railway station transfers, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Mumbai, we offer well-maintained vehicles driven by experienced chauffeurs to ensure a smooth and hassle-free journey. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles based on your travel requirements. We provide doorstep pickup, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support for a comfortable travel experience. Belgaum Taxi Service offers reliable cab services to all major destinations across Mumbai, including business districts, airports, railway stations, residential areas, hotels, hospitals, and tourist attractions, making long-distance travel convenient and stress-free.",

topPlaces: [
  {
    title: "Mumbai Airport",
    description: "Mumbai Airport is one of India's busiest airports, serving domestic and international travelers. Belgaum to Mumbai airport cab service offers timely transfers for business trips, vacations, and connecting flights."
  },
  {
    title: "Bandra Kurla Complex (BKC)",
    description: "BKC is Mumbai's leading commercial and financial hub, home to multinational companies, corporate offices, banks, and convention centers. It is a popular destination for business travelers."
  },
  {
    title: "Nariman Point",
    description: "Nariman Point is one of Mumbai's prime business districts, known for corporate headquarters, financial institutions, luxury hotels, and stunning Marine Drive views."
  },
  {
    title: "Lower Parel",
    description: "Lower Parel is a modern commercial and lifestyle destination featuring business parks, premium offices, shopping malls, restaurants, and entertainment venues."
  },
  {
    title: "Powai",
    description: "Powai is a prominent residential and IT hub known for Powai Lake, Hiranandani Gardens, corporate offices, educational institutions, and luxury hotels."
  },
  {
    title: "Navi Mumbai",
    description: "Navi Mumbai is a rapidly growing commercial city with business parks, industrial zones, educational institutions, and excellent connectivity across the Mumbai Metropolitan Region."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's iconic waterfront monument, attracting tourists from across the country for sightseeing, photography, and ferry rides."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most famous coastal promenades, offering beautiful sea views, evening walks, and a vibrant city atmosphere."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is a popular tourist attraction known for its lively atmosphere, street food, sunset views, and proximity to Mumbai's entertainment district."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple is one of Mumbai's most visited religious landmarks, attracting thousands of devotees and visitors throughout the year."
  }
],




"services": [
  {
    "name": "Belgaum to Mumbai Taxi Fare",
    "description": "Check Belgaum to Mumbai Taxi Fare with transparent pricing, fixed fare packages, and multiple vehicle options including Sedan, Ertiga, Innova Crysta, and SUVs. Enjoy affordable rates, professional chauffeurs, doorstep pickup, luggage assistance, one way and round trip options, airport transfers, corporate travel, family trips, and 24×7 booking support."
  },
  {
    "name": "Belgaum to Mumbai Taxi",
    "description": "Book Belgaum to Mumbai Taxi for safe and comfortable intercity travel with experienced drivers, clean AC vehicles, flexible pickup timings, and reliable customer support."
  },
  {
    "name": "Belgaum to Mumbai Car",
    "description": "Hire Belgaum to Mumbai Car with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles for business travel, family vacations, airport transfers, and holiday trips."
  },
  {
    "name": "Belgaum to Mumbai Cab",
    "description": "Reserve Belgaum to Mumbai Cab with fixed fares, instant online booking, professional chauffeurs, comfortable seating, and smooth highway travel."
  },
  {
    "name": "Belgaum to Mumbai Cab Service",
    "description": "Choose Belgaum to Mumbai Cab Service for dependable long-distance travel with AC vehicles, experienced drivers, transparent pricing, and comfortable intercity transportation."
  },
  {
    "name": "Belgaum to Mumbai Taxi Service",
    "description": "Travel with Belgaum to Mumbai Taxi Service offering punctual pickup, sanitized vehicles, affordable fares, luggage assistance, and premium travel comfort."
  },
  {
    "name": "Belgaum to Mumbai One Way Cab",
    "description": "Book Belgaum to Mumbai One Way Cab with direct destination drop, affordable pricing, instant confirmation, and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Belgaum to Mumbai Cab Booking",
    "description": "Complete Belgaum to Mumbai Cab Booking online with secure reservations, transparent fares, multiple cab options, and quick booking confirmation."
  },
  {
    "name": "Belgaum to Mumbai Car Rental",
    "description": "Hire Belgaum to Mumbai Car Rental for flexible outstation travel with Sedan, Ertiga, Innova Crysta, SUVs, and premium chauffeur-driven vehicles."
  },
  {
    "name": "Belgaum to Mumbai Outstation Cab",
    "description": "Reserve Belgaum to Mumbai Outstation Cab for comfortable long-distance travel with fixed pricing, experienced chauffeurs, and well-maintained AC vehicles."
  },
  {
    "name": "Belgaum to Mumbai Airport Cab",
    "description": "Book Belgaum to Mumbai Airport Cab for convenient airport transfers with timely pickup, luggage support, experienced drivers, and comfortable travel."
  },
  {
    "name": "Belgaum to Mumbai Airport Taxi",
    "description": "Choose Belgaum to Mumbai Airport Taxi for reliable airport transportation with fixed fares, clean vehicles, professional chauffeurs, and 24×7 availability."
  },
  {
    "name": "Belgaum to Mumbai Innova Crysta Cab",
    "description": "Reserve Belgaum to Mumbai Innova Crysta Cab for luxury family travel, business trips, group journeys, spacious seating, and premium comfort."
  },
  {
    "name": "Belgaum to Mumbai Ertiga Cab",
    "description": "Book Belgaum to Mumbai Ertiga Cab for affordable six-seater travel with ample luggage space, comfortable seating, and experienced chauffeurs."
  },
  {
    "name": "Belgaum to Mumbai Sedan Cab",
    "description": "Travel with Belgaum to Mumbai Sedan Cab for economical outstation transportation with AC vehicles, professional drivers, and smooth highway rides."
  },
  {
    "name": "Belgaum to Mumbai Round Trip Cab",
    "description": "Choose Belgaum to Mumbai Round Trip Cab with flexible return schedules, premium vehicles, transparent pricing, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Belgaum to Mumbai Private Taxi",
    "description": "Hire Belgaum to Mumbai Private Taxi for exclusive travel with complete privacy, flexible pickup timing, premium comfort, and reliable transportation."
  },
  {
    "name": "Cheap Belgaum to Mumbai Cab",
    "description": "Find Cheap Belgaum to Mumbai Cab with affordable fares, fixed pricing, clean AC vehicles, and dependable service without hidden charges."
  },
  {
    "name": "Best Belgaum to Mumbai Cab Service",
    "description": "Experience the Best Belgaum to Mumbai Cab Service with premium vehicles, courteous chauffeurs, fixed pricing, punctual pickup, and outstanding customer support."
  },
  {
    "name": "Online Belgaum to Mumbai Cab Booking",
    "description": "Reserve Online Belgaum to Mumbai Cab Booking with instant confirmation, secure payment, multiple vehicle choices, and 24×7 booking assistance."
  },
  {
    "name": "Belgaum to Mumbai Car Hire",
    "description": "Choose Belgaum to Mumbai Car Hire for chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles with flexible travel plans and affordable rates."
  },
  {
    "name": "Belgaum to Navi Mumbai",
    "description": "Book Belgaum to Navi Mumbai Cab with comfortable AC vehicles, professional chauffeurs, transparent pricing, and reliable outstation transportation."
  },
  {
    "name": "Belgaum to Navi Mumbai One Way",
    "description": "Reserve Belgaum to Navi Mumbai One Way Cab with direct destination drop, fixed fares, online booking, and experienced drivers."
  },
  {
    "name": "Belgaum to Mumbai One Way Cab",
    "description": "Travel with Belgaum to Mumbai One Way Cab offering affordable pricing, comfortable vehicles, quick booking confirmation, and safe intercity travel."
  },
  {
    "name": "Belgaum to Mumbai Round Trip Cab",
    "description": "Book Belgaum to Mumbai Round Trip Cab with flexible return options, premium chauffeur-driven vehicles, transparent pricing, and comfortable long-distance travel."
  }
],

"tableData": [
  ["Belgaum to Mumbai Taxi Fare", "Belgaum to Mumbai Taxi"],
  ["Belgaum to Mumbai Car", "Belgaum to Mumbai Cab"],
  ["Belgaum to Mumbai Cab Service", "Belgaum to Mumbai Taxi Service"],
  ["Belgaum to Mumbai One Way Cab", "Belgaum to Mumbai Cab Booking"],
  ["Belgaum to Mumbai Car Rental", "Belgaum to Mumbai Outstation Cab"],
  ["Belgaum to Mumbai Airport Cab", "Belgaum to Mumbai Airport Taxi"],
  ["Belgaum to Mumbai Innova Crysta Cab", "Belgaum to Mumbai Ertiga Cab"],
  ["Belgaum to Mumbai Sedan Cab", "Belgaum to Mumbai Round Trip Cab"],
  ["Belgaum to Mumbai Private Taxi", "Cheap Belgaum to Mumbai Cab"],
  ["Best Belgaum to Mumbai Cab Service", "Online Belgaum to Mumbai Cab Booking"],
  ["Belgaum to Mumbai Car Hire", "Belgaum to Navi Mumbai"],
  ["Belgaum to Navi Mumbai One Way", "Belgaum to Mumbai One Way Cab"],
  ["Belgaum to Mumbai Round Trip Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Mumbai Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service provides reliable Belgaum to Mumbai cab services with experienced drivers, comfortable vehicles, and safe long-distance travel for business and leisure."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Belgaum",
    WhyChoosedescription: "Get convenient pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and surrounding areas with direct drop anywhere in Mumbai."
  },
  {
    WhyChooseheading: "Wide Selection of Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel plans, passenger count, and luggage requirements."
  },
  {
    WhyChooseheading: "Professional Drivers for Highway Travel",
    WhyChoosedescription: "Our skilled chauffeurs are experienced in long-distance routes, ensuring a smooth, secure, and comfortable journey between Belgaum and Mumbai."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Options",
    WhyChoosedescription: "Book a one-way taxi to Mumbai or select a flexible round-trip package designed to match your travel schedule."
  },
  {
    WhyChooseheading: "Affordable Fare with Transparent Pricing",
    WhyChoosedescription: "Enjoy competitive cab rates with upfront quotations, customized travel packages, and no hidden charges."
  },
  {
    WhyChooseheading: "Ideal for Business, Family & Airport Transfers",
    WhyChoosedescription: "Our Belgaum to Mumbai cabs are suitable for corporate travel, family vacations, Mumbai Airport transfers, medical visits, and weekend trips."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Reserve your Belgaum to Mumbai cab anytime with instant booking confirmation and dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Mumbai cab service?",
    answer: "Yes, Belgaum Taxi Service offers one-way and round-trip taxi services from Belgaum to Mumbai with professional drivers and comfortable vehicles."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Mumbai?",
    answer: "Yes, one-way cab services are available with doorstep pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Mumbai travel?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup is available from Belgaum Airport, Railway Station, hotels, offices, and residential areas."
  },
  {
    question: "Can I book a cab to Mumbai Airport?",
    answer: "Yes, we provide direct taxi services from Belgaum to Mumbai Airport as well as any location within Mumbai."
  },
  {
    question: "Is Belgaum to Mumbai cab service available 24/7?",
    answer: "Yes, our taxi services are available 24 hours a day for your preferred departure time."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Can I book a return cab from Mumbai to Belgaum?",
    answer: "Yes, round-trip and return taxi services are available with flexible travel schedules."
  },
  {
    question: "Is this service suitable for corporate and family travel?",
    answer: "Yes, our Belgaum to Mumbai taxis are ideal for business trips, family vacations, airport transfers, medical visits, and group travel."
  },
  {
    question: "How can I book a Belgaum to Mumbai Cab?",
    answer: "Share your pickup location, Mumbai destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Kulkarni",
    feedback: "The Belgaum to Mumbai journey was comfortable and well-managed. The driver maintained excellent timing, and the vehicle was clean, spacious, and perfect for long-distance travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patwardhan",
    feedback: "Choosing Belgaum Taxi Service for our Mumbai trip was a great decision. The booking process was quick, the chauffeur was courteous, and the entire journey was safe and relaxing.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Mumbai Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-mumbai-cab.webp",
  "description":
    "Book Belgaum to Mumbai Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Mumbai with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-mumbai-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Belgaum to Mumbai Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Mumbai Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Mumbai with Sedan, Ertiga, SUV, Innova, and Innova Crysta for airport transfers, business trips, and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="belgaum to mumbai taxi fare, belgaum to mumbai taxi, belgaum to mumbai car, Belgaum to Mumbai Cab, Belgaum to Mumbai Taxi, Belgaum to Mumbai Cab Service, Belgaum Mumbai Taxi Booking, Belgaum to Mumbai One Way Cab, Belgaum to Mumbai Outstation Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtomumbaicab;